import React, { useEffect, useState, useContext, useRef } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAddressCard } from "@fortawesome/free-regular-svg-icons";
import { faList, faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import "./Customers.css";
import ListWithFilters from "../ListWithFilters/ListWithFilters";
import AddCustomerModal from "./AddCustomerModal";
import SocketContext from "../../contexts/SocketContext";
import CustomerCards from "./CustomerCards";
import { gsap } from "gsap";

const Customers = () => {
  // General
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();

  // Socket
  const { socket } = useContext(SocketContext);

  // States to hold Data and ListData
  const [data, setData] = useState();
  const [listdata, setListData] = useState();
  const [reloaddata, setReloaddata] = useState(false);

  // View State
  const [viewlist, setViewlist] = useState(true);

  // Show Hide
  const [showCustDetails, setShowCustDetails] = useState(false); //customer details
  const [showAddCustomerModal, setShowAddCustomerModal] = useState(false); //add customer modal

  // Success Message
  const successMSGRef = useRef();
  const [showsuccess, setShowsuccess] = useState(false);
  const [successMSG, setSuccessMSG] = useState("");

  // Selected Customer
  const [selectedCustomer, setSelectedCustomer] = useState();

  // Card View
  const [customerfilter, setCustomerfilter] = useState("");
  const [custcarddata, setCustcarddata] = useState();

  // Join and Leave Suppliers Room
  useEffect(() => {
    socket.emit("joincustomersroom");
    return () => {
      socket.emit("leavecustomersroom");
    };
  }, []);

  // Load all customers and set them in Data
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getCustomers = async () => {
      try {
        const response = await axiosPrivate.get("api/customers/getcustomers");
        isMounted && setListData(response.data);
        isMounted && setData(response.data);
      } catch (err) {
        navigate("/login", { state: { from: location }, replace: true });
      }
    };
    getCustomers();
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [reloaddata]);

  // Filter Card Data
  useEffect(() => {
    if (listdata && listdata.length > 0) {
      if (customerfilter) {
        let temp = listdata.filter(
          (item) =>
            item.companyCode?.toLowerCase().includes(customerfilter?.toLowerCase()) ||
            item.companyName?.toLowerCase().includes(customerfilter?.toLowerCase()) ||
            item.country?.toLowerCase().includes(customerfilter?.toLowerCase()) ||
            item.city?.toLowerCase().includes(customerfilter?.toLowerCase()) ||
            item.region?.toLowerCase().includes(customerfilter?.toLowerCase())
        );
        setCustcarddata(temp);
      } else {
        setCustcarddata(listdata);
      }
    }
  }, [customerfilter, listdata]);

  // Select Customer Function to pass to List With Filters
  const selectCustomer = (item) => {
    setShowCustDetails(true);
    setSelectedCustomer(item);
    if (location.pathname === "/admin/customers") {
      navigate("/admin/customers/customerdetails", { state: { from: location }, replace: true });
    }
  };

  // Socket Functions
  const receivednewcustomer = (newitem) => {
    console.log(newitem);
    socket && setListData((prev) => [...prev, newitem]);
  };
  const receivedupdatecustomer = (item) => {
    console.log(item);
    socket &&
      setListData((prev) => {
        let ind = prev.findIndex((it) => it.customerID === item.customerID);
        if (ind !== -1) {
          return [...prev.slice(0, ind), item, ...prev.slice(ind + 1, prev.length)];
        } else return [...prev];
      });
  };
  const receiveddeletecustomer = (item) => {
    if (socket) {
      setListData((prev) => {
        let ind = prev.findIndex((it) => it.customerID === item);
        if (ind !== -1) {
          return [...prev.slice(0, ind), ...prev.slice(ind + 2, prev.length)];
        } else return [...prev];
      });
    }
  };

  // Suscribe to Socket Events
  useEffect(() => {
    socket.on("enewcustomer", (newitem) => {
      receivednewcustomer(newitem);
    });
    socket.on("eupdatecustomer", (item) => {
      receivedupdatecustomer(item);
    });
    socket.on("edeletecustomer", (item) => {
      receiveddeletecustomer(item);
    });
    return () => {
      socket.off("enewcustomer");
      socket.off("eupdatecustomer");
      socket.off("edeletecustomer");
    };
  }, [socket]);

  // Show Success Msg
  const onSPMComplete = () => {
    setSuccessMSG(null);
  };
  useEffect(() => {
    const elem = successMSGRef.current;
    if (successMSG) {
      gsap.fromTo(elem, { opacity: 0.5, top: "-20px" }, { opacity: 1, top: 0, duration: 0.1, ease: "power2.in" });
      gsap.fromTo(
        elem,
        { opacity: 1 },
        {
          opacity: 0,
          duration: 3,
          ease: "power2.inOut",
          onComplete: onSPMComplete,
        }
      );
    }
  }, [showsuccess]);

  return (
    <div className='customerList'>
      <AddCustomerModal
        show={showAddCustomerModal}
        setShow={setShowAddCustomerModal}
        reloaddata={reloaddata}
        setReloaddata={setReloaddata}
      />
      <div className='clheader'>
        <div className='clsubheader'>
          {viewlist && <h1>Customer List</h1>}
          {!viewlist && <h1>Customer Cards</h1>}
        </div>
        <div className='success-msg' ref={successMSGRef}>
          {successMSG}
        </div>
        <div className='viewcustomersas'>
          <p>View as:</p>
          <FontAwesomeIcon
            className='viewcusticon'
            icon={faList}
            onClick={(e) => {
              setViewlist(true);
            }}
          />
          <FontAwesomeIcon
            className='viewcusticon'
            icon={faAddressCard}
            onClick={(e) => {
              setViewlist(false);
            }}
          />
          <FontAwesomeIcon
            className='viewprodicon'
            icon={faPlusSquare}
            onClick={(e) => {
              setShowAddCustomerModal(true);
            }}
          />
        </div>
      </div>
      {!viewlist && (
        <input
          className='customercardsearch'
          placeholder='search'
          type='text'
          onChange={(e) => setCustomerfilter(e.target.value)}
        />
      )}
      <div className='customerListContent'>
        {!viewlist && (
          // CARD LIST VIEW
          <CustomerCards data={custcarddata} onCardClick={selectCustomer} />
        )}
        {viewlist && (
          //CUSTOMER LIST VIEW
          <ListWithFilters
            data={listdata}
            columns={["companyCode", "companyName", "city", "country", "region"]}
            rowID={"customerID"}
            sortable={true}
            sortDirections={["ASC", "NON", "NON", "ASC", "NON"]}
            size={["M", "L", "M", "M", "M"]}
            onRowClick={selectCustomer}
            placeHolders={true}
            rowIndex={true}
            placeHolderList={["Company Code", "Company Name", "City", "Country", "Region"]}
          />
        )}
        {selectedCustomer && (
          <Outlet
            context={[
              showCustDetails,
              selectedCustomer,
              setSelectedCustomer,
              setReloaddata,
              reloaddata,
              setShowsuccess,
              setSuccessMSG,
            ]}
          />
        )}
      </div>
    </div>
  );
};

export default Customers;
